import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IXAxisConfigColumnFormValue {
    columnId: string;
    title?: string;
    type: INameId;
    belongingYear: INameId;
}

export interface ISuperTableSegmentFormValue {
    title?: string;
    childColsIds: INameId[];
}

export interface ISuperTableOptionsFormValue {
    title: string;
    xAxisConfig: IXAxisConfigColumnFormValue[];
    segments: ISuperTableSegmentFormValue[];
    compareYears: boolean;
    hideCurrentYear: boolean;
    showFiscalYear: boolean;
    transpose: boolean;
    showCurrency: boolean;
}
